import { VIcon } from 'vuetify/lib'
import {postEpopMonthlyRecordAddUnusualChangeApi, postEpopMonthlyRecordRemoveUnusualChangeApi} from '@/views/fin/account_management/services.js'
import VForm from '@/vuetify_custom/v-form'
import styles from '@/views/fin/account_management/index.module.less'
import VModal from '@/vuetify_custom/v-modal_v1'
import { getsafe, formattingNumber } from '@/libs/util'
export default {
    props: {
        canEdit: {
            type: Boolean,
        },
        type:{
            type: String,
        },
        title: {
            type: String,
            default: () => ''
        },
        target: {
            type: Object
        }
    },
    data() {
        return {
            params: {
                change_type: null,
                change_amount: null,
            },
            show: false,
            loading: false,
        }
    },
    computed: {
        fields() {
            return [
                {
                    label: '变动类型',
                    key:'change_type',
                    type:'select_field',
                    'item-text': 'title',
                    'item-value': 'title',
                    items:[{title: '返款'}, {title: '扣款'}, {title: '其他'}],
       
                    required: true,
                    rules: [ v => !!v || '必选'],
                },
                {
                    label: '金额',
                    key:'change_amount',
                    type:'number_field',
                    d_digits:2,
                    required: true,
                    rules: [ v => ![null, undefined, ''].includes(v) || '必选'],
                }
            ]
        }
    },
    methods: {
        addNewUnusua() {
            this.show = true
            this.params.id = this.target.id
            this.params.change_type = null
            this.params.change_amount = null
            this.$refs.form.resetFields()
        },
        delete(item) {
            this.$vModal.confirm({
                title: '提示',
                content: `确定删除该条异常变动（${item.change_type}/${formattingNumber(item.change_amount, 2)}）`,
                loading:true,
                onOk:({destroy, stopLoading}) => {
                    postEpopMonthlyRecordRemoveUnusualChangeApi({
                        id: this.target.id,
                        change_id:item.id,
                    }).then(() => {
                      this.$emit('success')
                      this.$Message.success('数据删除成功！')  
                    }).finally(() => {
                        stopLoading()
                        destroy()
                    })
                }
            })
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true
                postEpopMonthlyRecordAddUnusualChangeApi(this.params).then(() => {
                    this.$emit('success')
                    this.$Message.success('数据保存成功！')  
                    this.show = false
                }).finally(() => {
                    this.loading = false
                })
            }
        
        }
    },
    render() {
        const unusual_changes = getsafe(this.target, 'unusual_changes', [])
        return <div >
        {!!this.canEdit && <span class={styles['btn']} on={{click:this.addNewUnusua }}> <VIcon small color="primary" >mdi-plus-circle-outline</VIcon></span>}
        {!!unusual_changes.length && <div>
            {unusual_changes.map(item => {
                return <p style="display:flex">
                        {item.change_type} {formattingNumber(item.change_amount, 2)} 
                        {!!this.canEdit && <span class={styles['btn']} on={{click: () => this.delete(item) }}> <VIcon small color="warning" >mdi-delete-circle-outline</VIcon></span>}
                    </p>
            })}
        </div>}
                <VModal
                v-model={this.show}
                dynamicHeight
                heightRate={0.5}
                title="异常变动"
                loading={this.loading}
                width={500}
                ref="modal"
                ok-text="保存"
                on={{
                    ok: () => {
                        this.submit() 
                    },
                }}
                >
                    <VForm 
                        ref="form" 
                        fields={this.fields} 
                        v-model={this.params}
                    />
                </VModal>
</div>
    }
}